import { render } from "./TangkiSelenggara.vue?vue&type=template&id=537ce679"
import script from "./TangkiSelenggara.vue?vue&type=script&lang=js"
export * from "./TangkiSelenggara.vue?vue&type=script&lang=js"

import "./TangkiSelenggara.vue?vue&type=style&index=0&id=537ce679&lang=css"

import exportComponent from "/var/www/html/aims/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__